import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./Services.css";
import Cosection from '../components/Cosections';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';

// ✅ Unique react-icons (NONE repeated)
import {
  FaRegFileAlt,
  FaEdit,
  FaIdCard,
  FaGlobeAmericas,
  FaPenFancy,
  FaClock,
  FaMoneyCheckAlt,
  FaChartPie,
  FaBalanceScale,
  FaPaperPlane,
  FaBuilding,
  FaChartLine,
  FaCalculator,
  FaCreditCard,
  FaPlaneDeparture,
  FaSearch,
} from "react-icons/fa";

import { MdKeyboardDoubleArrowRight } from "react-icons/md";

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Individual Services (unique icons)
  const individualServices = [
    { title: 'Federal & State Tax Filing', description: 'Accurate tax filing with expert planning. Free yourself from tax stress.', link: '/federal', icon: <FaRegFileAlt /> },
    { title: 'Amendment', description: 'Correct past returns, claim deductions, and get money back.', link: '/amendment', icon: <FaEdit /> },
    { title: 'ITIN Preparation', description: 'Certified agent assistance for Form W-7 and IRS submission.', link: '/itinpreparation', icon: <FaIdCard /> },
    { title: 'FBAR & FATCA', description: 'Report foreign financial accounts & assets accurately and avoid penalties.', link: '/fbar', icon: <FaGlobeAmericas /> },
    { title: 'W4 Assistance', description: 'Ensure correct withholding and avoid large tax surprises.', link: '/w4assistance', icon: <FaPenFancy /> },
    { title: 'Tax Extension Filing', description: 'Request a filing extension and stay penalty-free.', link: '/taxextension', icon: <FaClock /> },
    { title: 'Estimate Tax Payments', description: 'Avoid penalties on quarterly taxes — we calculate and file.', link: '/estimatetax', icon: <FaMoneyCheckAlt /> },
    { title: 'Tax Planning', description: 'Strategic tax planning to reduce liability and improve savings.', link: '/taxplanning', icon: <FaChartPie /> },
    { title: 'Tax Representation before IRS', description: 'IRS audits & notices handled by our experts.', link: '/representation', icon: <FaBalanceScale /> },
    { title: 'Filing Options', description: 'Choose between e-filing or traditional paper filing.', link: '/filingoptions', icon: <FaPaperPlane /> },
  ];

  // Business Services (unique icons)
  const businessServices = [
    { title: 'Business Incorporation', description: 'Seamless company formation with expert setup guidance.', link: '/business', icon: <FaBuilding /> },
    { title: 'Business Tax Returns', description: 'Full filing support for all business entity types.', link: '/businessreturns', icon: <FaChartLine /> },
    { title: 'Accounting & Bookkeeping', description: 'QuickBooks & Xero bookkeeping — stay tax-ready all year.', link: '/bookkeeping', icon: <FaCalculator /> },
    { title: 'Payroll Processing Services', description: 'Gusto/ADP payroll setup with compliance.', link: '/payroll', icon: <FaCreditCard /> },
    { title: 'International Business Tax Forms', description: 'Forms 5471, 5472, 8865 — avoid penalties.', link: '/international', icon: <FaPlaneDeparture /> },
    { title: 'BOIR', description: 'BOIR filing to meet U.S. federal compliance.', link: '/boir', icon: <FaSearch /> },
  ];

  return (
    <div className="services-page-wrapper">
      <NavBar />

      {/* Hero Section */}
      <div className="services-hero">
        <div className="services-hero-content">
          <h1 className="services-hero-title">Comprehensive Tax Services</h1>
          <p className="services-hero-subtitle">
            Expert tax solutions for individuals and businesses. Maximize your refund, minimize stress.
          </p>
        </div>
        <div className="services-hero-overlay" />
      </div>

      <div className="services-content-wrapper">

        {/* Individual Services */}
        <div className="services-section">
          <div className="services-section-header">
            <h2>Individual Tax Services</h2>
            <p>Professional tax solutions tailored to your financial situation</p>
          </div>

          <div className="services-grid">
            {individualServices.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">{service.icon}</div>
                  <h3 className="service-title">{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  Learn More <MdKeyboardDoubleArrowRight />
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* Business Services */}
        <div className="services-section">
          <div className="services-section-header">
            <h2>Business Tax Services</h2>
            <p>Tax, payroll, compliance, and complete business support</p>
          </div>

          <div className="services-grid">
            {businessServices.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">{service.icon}</div>
                  <h3 className="service-title">{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  Learn More <MdKeyboardDoubleArrowRight />
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="services-cta-section">
          <div className="services-cta-content">
            <h2>Not Sure Which Service You Need?</h2>
            <p className="services-cta-text">Get a free consultation and let our experts guide you</p>
            <div className="services-cta-buttons">
              {/* Link to Contact page */}
              <Link to="/contact" className="services-cta-button services-cta-primary">
                Get Free Consultation
              </Link>
            </div>
            
            {/* Phone number */}
            <div className="services-phone-display">
              <p>Call us at: <a href="tel:+19453584442" className="services-phone-link">+1 (945)-358-4442</a></p>
            </div>
          </div>
        </div>

      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Services;